import { render, staticRenderFns } from "./AddCustomerWizardControl.global.vue?vue&type=template&id=22312d3d&lang=pug&"
import script from "./AddCustomerWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./AddCustomerWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports